import { getData } from "#Utils/dom"

document.addEventListener("change", (e) => {
  if (!e.target.matches(".member_options")) return

  let question
  const form = e.target.closest("form")
  const method = form.querySelector("[name=_method]")

  switch (e.target.value) {
    case "make_owner":
      question = "Promote this member to owner?"
      method.value = "post"
      form.setAttribute("action", getData(form, "add-owner-path"))
      break
    case "make_member":
      question = "Demote this owner to member?"
      method.value = "delete"
      form.setAttribute("action", getData(form, "remove-owner-path"))
      break
    case "remove_member":
      question = "Remove this member from organization?"
      method.value = "delete"
      form.setAttribute("action", getData(form, "remove-member-path"))
      break
  }

  if (question) {
    const answer = confirm(question)
    if (answer) {
      form.submit()
    }
  }
})
